import {
  BaseApiFetchClientConstructor,
} from '@ama-sdk/core';
import {
  BidiModule,
} from '@angular/cdk/bidi';
import {
  OverlayConfig,
} from '@angular/cdk/overlay';
import {
  Platform,
} from '@angular/cdk/platform';
import {
  STEPPER_GLOBAL_OPTIONS,
} from '@angular/cdk/stepper';
import {
  DOCUMENT,
} from '@angular/common';
import {
  HttpClientModule,
} from '@angular/common/http';
import {
  NgModule,
  Optional,
  Provider,
} from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_RIPPLE_GLOBAL_OPTIONS,
  MatNativeDateModule,
} from '@angular/material/core';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule,
} from '@angular/material/dialog';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from '@angular/material/form-field';
import {
  BrowserModule,
} from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
} from '@angular/platform-browser/animations';
import {
  ServiceWorkerModule,
} from '@angular/service-worker';
import {
  DebugPanelPresComponent,
} from '@des/debug-panel';
import {
  ErrorsHandlerModule,
} from '@des/services/errors-handler';
import {
  LOG_SERVER_LOGGER_CLIENT_OPTIONS,
} from '@des/services/logging';
import {
  BOARDING_PASSES_STORE_NAME,
  boardingPassesStorageDeserializer,
  boardingPassesStorageSync,
  BoardingPassesStoreModule,
} from '@des/store/boarding-passes';
import {
  CHECK_IN_BAGGAGE_POLICIES_STORE_NAME,
  checkInBaggagePoliciesStorageSync,
} from '@des/store/check-in-baggage-policies';
import {
  CHECK_IN_PAYMENT_RECORDS_STORE_NAME,
  checkInPaymentRecordsStorageSync,
  CheckInPaymentRecordsStoreModule,
} from '@des/store/check-in-payment-records';
import {
  JOURNEY_ALTERNATIVE_OFFERS_STORE_NAME,
  journeyAlternativeOffersStorageSync,
} from '@des/store/journey-alternative-offers';
import {
  JourneyBagTagsStoreModule,
} from '@des/store/journey-bag-tags';
import {
  JOURNEY_UNPAID_ITEMS_STORE_NAME,
  journeyUnpaidItemsStorageSync,
  JourneyUnpaidItemsStoreModule,
} from '@des/store/journey-unpaid-items';
import {
  JOURNEYS_STORE_NAME,
  journeysStorageDeserializer,
  JourneysStoreModule,
} from '@des/store/journeys';
import {
  JOURNEYS_SELECTION_CRITERIA_STORE_NAME,
  journeysSelectionCriteriaStorageSync,
} from '@des/store/journeys-selection-criteria';
import {
  MessagesBaseStoreModule,
} from '@des/store/messages';
import {
  RegulatoryDetailsStoreModule,
} from '@des/store/regulatory-details';
import {
  SeatmapsStoreModule,
} from '@des/store/seatmaps';
import {
  EffectsModule,
} from '@ngrx/effects';
import {
  routerReducer,
  StoreRouterConnectingModule,
} from '@ngrx/router-store';
import {
  Action,
  ActionReducer,
  createReducer,
  StoreModule,
  USER_RUNTIME_CHECKS,
} from '@ngrx/store';
import {
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import {
  EVENT_TRACK_SERVICE_CONFIGURATION,
  EventTrackService,
} from '@o3r/analytics';
import {
  API_TOKEN,
  ApiManager,
  ApiManagerModule,
} from '@o3r/apis-manager';
import {
  PlaceholderModule,
  PlaceholderRequestStoreModule,
  provideCustomComponents,
} from '@o3r/components';
import {
  PlaceholderRulesEngineActionModule,
} from '@o3r/components/rules-engine';
import {
  CONFIG_OVERRIDE_STORE_NAME,
  configOverrideStorageSync,
  ConfigOverrideStoreModule,
  CONFIGURATION_STORE_NAME,
  configurationAdapter,
  ConfigurationBaseServiceModule,
  ConfigurationDevtoolsModule,
  configurationReducerFeatures,
  configurationStorageSync,
  ConfigurationStoreModule,
} from '@o3r/configuration';
import {
  ConfigurationRulesEngineActionModule,
} from '@o3r/configuration/rules-engine';
import {
  AssetPathOverrideStoreModule,
  DynamicContentModule,
  RequestParametersModule,
  RequestParametersService,
} from '@o3r/dynamic-content';
import {
  AssetRulesEngineActionModule,
} from '@o3r/dynamic-content/rules-engine';
import {
  CUSTOM_LOCALIZATION_CONFIGURATION_TOKEN,
  LocalizationDevtoolsModule,
  LocalizationModule,
  LocalizationOverrideStoreModule,
  MESSAGE_FORMAT_CONFIG,
  TextDirectionality,
  translateLoaderProvider,
  TranslateMessageFormatLazyCompiler,
} from '@o3r/localization';
import {
  LocalizationRulesEngineActionModule,
} from '@o3r/localization/rules-engine';
import {
  LoggerModule,
  LoggerService,
} from '@o3r/logger';
import {
  AppServerRoutingModule,
  ENVIRONMENT_CONFIG_TOKEN,
} from '@o3r/routing';
import {
  RULES_ENGINE_OPTIONS,
  RulesEngineDevtoolsModule,
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  StorageSync,
} from '@o3r/store-sync';
import {
  AIRPORT_CITY_MAPPER_SERVICE_TOKEN,
  ANALYTICS_STORE_NAME,
  AnalyticsModule,
  AnalyticsService,
  analyticsStorageSync,
  LAZY_LOADER_SERVICE_TOKEN,
} from '@refx/analytics-core';
import {
  DigitalDataCustomWindowEventEffect,
} from '@refx/analytics-effects/custom-window-event';
import {
  AnalyticsErrorEffect,
} from '@refx/analytics-effects/error';
import {
  AnalyticsFormErrorMessagesEffect,
} from '@refx/analytics-effects/form-error';
import {
  AnalyticsJourneyEffect,
} from '@refx/analytics-effects/journey';
import {
  AnalyticsWarningEffect,
} from '@refx/analytics-effects/warning';
import {
  AppBootstrapConfig,
  BOOTSTRAP_CONFIGURATION_TOKEN,
  BOT_PROTECTION_FACTORY,
  BotProtectionFactory,
  createErrorsHandlerServiceConfig,
  createRequestParametersConfig,
  CustomTranslationsLoader,
  dateFnsFormatDMY,
  DEFAULT_EXTRA_PLUGINS_BY_API,
  DefaultBotProtectionFactory,
  EXPERIMENT_ANALYTICS_INTERFACE_TOKEN,
  EXTENSION_FEATURE_FLAGS_TOKEN,
  EXTRA_PLUGINS_BY_API_TOKEN,
  ExtraPluginsByAPI,
  GregorianDateFnsAdapter,
  prefersReducedMotion,
  REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_DEFAULT,
  REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_ID,
  refxDialogConfig,
  refxFormFieldOptions,
  refxOverlayConfig,
  refxRippleOptions,
  refxStepperGlobalOptions,
} from '@refx/shared-common';
import {
  AppLayoutModule,
  DebugLinkPresComponent,
  FooterPresModule,
  GifSpinnerModule,
  HeaderContModule,
  LazyOutletModule,
} from '@refx/shared-components';
import {
  aggregateBootstrapConfiguration,
  AirportToCityMapperService,
  AnalyticsUtilityModule,
  AppConfigModule,
  AppInitializationModule,
  AppInitializationService,
  DocumentTitleModule,
  DynamicLocaleModule,
  DynamicLocaleService,
  FunctionalContentOverrideRulesEngineActionModule,
  getAppLocaleFactory,
  getRulesEngineOptions,
  LazyLoaderService,
  LIBPHONENUMBER_TOKEN,
  SelectedDataModule,
  TagsModule,
  UiMessageModule,
} from '@refx/shared-services';
import {
  BREADCRUMB_STORE_NAME,
  breadcrumbStorageSync,
  BreadcrumbStoreModule,
  CATALOG_SERVICES_STORE_NAME,
  catalogServicesStorageSync,
  ServerMessagesEffect,
  TravelerDetailsUIStoreModule,
  UI_STATUS_STORE_NAME,
  uiStatusStorageSync,
  UiStatusStoreModule,
} from '@refx/shared-store';
import {
  OVERRIDE_COMPONENTS_COMMON_RUNTIME_CONFIG,
  REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_DEFAULT,
  REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_ID,
} from '@refx/ssci-common';
import {
  CANCEL_CHECKIN_STORE_NAME,
  cancelCheckinStorageSync,
  CancelCheckinStoreModule,
  MULTI_LEG_SEAT_SELECTIONS_STORE_NAME,
  multiLegSeatSelectionsStorageSync,
  ORIGINAL_JOURNEYS_DETAILS_STORE_NAME,
  originalJourneyDetailsStorageSync,
  OriginalJourneyDetailsStoreModule,
  SSCI_PAYMENT_STATUS_STORE_NAME,
  ssciPaymentStatusStorageSync,
  SsciPaymentStatusStoreModule,
} from '@refx/ssci-store';
import dateFnsLocaleEnGB from 'date-fns/locale/en-GB';
import {
  AppSkeletonPresComponent,
} from 'src/components';
import {
  AnalyticsEffect,
  RefxJourneyAcceptanceEffect,
} from 'src/effects/index';
import {
  createApisFactorySSCI,
  getAnalyticsConfiguration,
  getDigitalTouchpointData,
  getRuntimeChecksConfig,
  SSCI_APP_BOOTSTRAP_CONFIG_DEFAULT,
  SSCI_SERVER_LOGGER_CLIENT_OPTIONS,
} from '../configuration/index';
import {
  initializeCustomProviders,
} from '../customization/custom-providers.empty';
import {
  initializeEntryComponents,
  registerCustomComponents,
} from '../customization/presenters-map.empty';
import {
  environment,
} from '../environments/environment';
import {
  AppPreferencesFactsModule,
  CheckoutPaymentInformationFactsModule,
  DeviceDetectionFactsModule,
  JourneyInformationFactsModule,
  PortalFactsModule,
  SeatmapFactsModule,
  TechnicalDetailsFactsModule,
} from '../facts/index';
import {
  DEFAULT_FEATURE_FLAGS,
} from './../configuration/feature-flags';
import {
  AppComponent,
} from './app.component';
import {
  AppRoutingModule,
} from './app.routing.module';

/**
 * @param reducer
 */
export function storageSyncWrapper<T, V extends Action = Action>(reducer: ActionReducer<T, V>): ActionReducer<T, V> {
  const storageStates: any = [
    {
      [JOURNEYS_STORE_NAME]: {
        deserialize: journeysStorageDeserializer
      }
    },
    {
      [JOURNEYS_SELECTION_CRITERIA_STORE_NAME]: journeysSelectionCriteriaStorageSync
    },
    {
      [CHECK_IN_PAYMENT_RECORDS_STORE_NAME]: checkInPaymentRecordsStorageSync
    },
    {
      [SSCI_PAYMENT_STATUS_STORE_NAME]: ssciPaymentStatusStorageSync
    },
    {
      [UI_STATUS_STORE_NAME]: uiStatusStorageSync
    },
    {
      [ANALYTICS_STORE_NAME]: analyticsStorageSync
    },
    {
      [JOURNEY_UNPAID_ITEMS_STORE_NAME]: journeyUnpaidItemsStorageSync
    },
    {
      [BOARDING_PASSES_STORE_NAME]: {
        ...boardingPassesStorageSync,
        deserialize: boardingPassesStorageDeserializer
      }
    },
    {
      [CONFIGURATION_STORE_NAME]: configurationStorageSync
    },
    {
      [CHECK_IN_BAGGAGE_POLICIES_STORE_NAME]: checkInBaggagePoliciesStorageSync
    },
    {
      [BREADCRUMB_STORE_NAME]: breadcrumbStorageSync
    },
    {
      [CANCEL_CHECKIN_STORE_NAME]: cancelCheckinStorageSync
    },
    {
      [CATALOG_SERVICES_STORE_NAME]: catalogServicesStorageSync
    },
    {
      [CONFIG_OVERRIDE_STORE_NAME]: configOverrideStorageSync
    },
    {
      [MULTI_LEG_SEAT_SELECTIONS_STORE_NAME]: multiLegSeatSelectionsStorageSync
    },
    {
      [ORIGINAL_JOURNEYS_DETAILS_STORE_NAME]: originalJourneyDetailsStorageSync
    },
    {
      [JOURNEY_ALTERNATIVE_OFFERS_STORE_NAME]: journeyAlternativeOffersStorageSync
    }
  ];
  return new StorageSync({
    keys: storageStates,
    rehydrate: true,
    storage: sessionStorage || localStorage
  }).localStorageSync()(reducer);
}

const rootReducers = {
  router: routerReducer
};

const metaReducers = [...(environment.ENABLE_WEBSTORAGE ? [storageSyncWrapper] : [])];

const entry = initializeEntryComponents();
const customProviders: Provider[] = initializeCustomProviders();

/**
 * Configuration reducer specific to SSCI to add default global configuration in the initial state of the configuration store
 */
function ssciConfigurationReducer() {
  const initialState = configurationAdapter.upsertMany([{
    id: REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_ID,
    ...REFX_COMPONENTS_COMMON_RUNTIME_CONFIG_DEFAULT,
    ...OVERRIDE_COMPONENTS_COMMON_RUNTIME_CONFIG
  }, {
    id: REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_ID,
    ...REFX_COMPONENTS_SSCI_RUNTIME_CONFIG_DEFAULT
  }], configurationAdapter.getInitialState({}));

  return createReducer(
    initialState,
    ...configurationReducerFeatures
  );
}

/**
 * Overrride SSCI APIS factory with base path for safe travel
 *
 * @param appBootstrapConfig
 * @param botProtectionFactory
 * @param eventTrackService
 * @param requestParametersService
 * @param appInitializationService
 * @param platform
 * @param extraPluginsByAPI
 * @param loggerService
 */
export function overrideApisFactorySSCI(
  appBootstrapConfig: AppBootstrapConfig,
  botProtectionFactory: BotProtectionFactory,
  eventTrackService: EventTrackService,
  requestParametersService: RequestParametersService,
  appInitializationService: AppInitializationService,
  platform: Platform,
  extraPluginsByAPI: ExtraPluginsByAPI,
  loggerService?: LoggerService
): ApiManager {
  const basePath = `${appBootstrapConfig.gatewayBaseUrl}/v3`;
  const customApiClients: {[key: string]: BaseApiFetchClientConstructor;} = {
    HealthTravelConditionsRetrievalApi: {
      basePath
    },
    HealthDocumentsVerificationReportsApi: {
      basePath
    },
    HealthDocumentsScanVerifyApi: {
      basePath
    },
    HealthPassesVerificationApi: {
      basePath
    },
    ResumeHealthDocumentsProcessApi: {
      basePath
    }
  };

  return createApisFactorySSCI(appBootstrapConfig, botProtectionFactory, eventTrackService, requestParametersService, appInitializationService, platform, extraPluginsByAPI, customApiClients, loggerService);
}

@NgModule({
  imports: [
    BidiModule,
    BrowserModule,
    BrowserAnimationsModule.withConfig({
      disableAnimations: prefersReducedMotion()
    }),
    ApiManagerModule,
    AppSkeletonPresComponent,
    DebugLinkPresComponent,
    RequestParametersModule.forRoot(createRequestParametersConfig),
    LocalizationModule.forRoot(),
    TranslateModule.forRoot({
      loader: translateLoaderProvider,
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatLazyCompiler
      }
    }),
    AppRoutingModule,
    AssetPathOverrideStoreModule,
    StoreModule.forRoot(rootReducers, {
      metaReducers
    }),
    EffectsModule.forRoot([
      AnalyticsErrorEffect,
      AnalyticsFormErrorMessagesEffect,
      AnalyticsJourneyEffect,
      AnalyticsWarningEffect,
      RefxJourneyAcceptanceEffect,
      AnalyticsEffect,
      ServerMessagesEffect,
      DigitalDataCustomWindowEventEffect
    ]),
    ConfigurationStoreModule.forRoot(ssciConfigurationReducer),
    StoreRouterConnectingModule.forRoot(),
    ...(environment.modules || []),
    AppServerRoutingModule.forRoot(environment),
    AppConfigModule,
    RulesEngineRunnerModule.forRoot({}),
    GifSpinnerModule,
    ConfigurationBaseServiceModule,
    DebugPanelPresComponent,
    ConfigurationDevtoolsModule.instrument({
      defaultLibraryName: '@refx/shared-components'
    }),
    LocalizationDevtoolsModule,
    RulesEngineDevtoolsModule,
    PlaceholderRulesEngineActionModule,
    ConfigurationRulesEngineActionModule,
    AssetRulesEngineActionModule,
    PlaceholderRequestStoreModule,
    LocalizationRulesEngineActionModule,
    FunctionalContentOverrideRulesEngineActionModule,
    OriginalJourneyDetailsStoreModule,
    ...entry.customComponentsModules,
    DocumentTitleModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    LazyOutletModule,
    DynamicContentModule,
    DynamicLocaleModule,
    AppInitializationModule,
    AnalyticsUtilityModule,
    MessagesBaseStoreModule,
    JourneyBagTagsStoreModule,
    TravelerDetailsUIStoreModule,
    MatDialogModule,
    AppPreferencesFactsModule,
    AnalyticsModule.forRoot(getAnalyticsConfiguration, getDigitalTouchpointData),
    AppLayoutModule,
    FooterPresModule,
    HeaderContModule,
    MatNativeDateModule,
    JourneysStoreModule,
    SeatmapsStoreModule,
    BoardingPassesStoreModule,
    RegulatoryDetailsStoreModule,
    SeatmapFactsModule,
    SsciPaymentStatusStoreModule,
    TechnicalDetailsFactsModule,
    CheckInPaymentRecordsStoreModule,
    JourneyUnpaidItemsStoreModule,
    BreadcrumbStoreModule,
    CancelCheckinStoreModule,
    UiMessageModule,
    UiStatusStoreModule,
    HttpClientModule,
    CheckoutPaymentInformationFactsModule,
    DeviceDetectionFactsModule,
    JourneyInformationFactsModule,
    PortalFactsModule,
    TagsModule,
    ConfigOverrideStoreModule,
    LocalizationOverrideStoreModule,
    LoggerModule,
    PlaceholderModule,
    ErrorsHandlerModule.forRoot({
      factory: createErrorsHandlerServiceConfig,
      deps: [ENVIRONMENT_CONFIG_TOKEN, BOOTSTRAP_CONFIGURATION_TOKEN]
    }),
    SelectedDataModule
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    provideCustomComponents(registerCustomComponents()),
    {
      provide: BOOTSTRAP_CONFIGURATION_TOKEN,
      useFactory: aggregateBootstrapConfiguration(SSCI_APP_BOOTSTRAP_CONFIG_DEFAULT),
      deps: [
        DOCUMENT,
        RequestParametersService
      ]
    },
    {
      provide: API_TOKEN,
      useFactory: overrideApisFactorySSCI,
      deps: [
        BOOTSTRAP_CONFIGURATION_TOKEN,
        BOT_PROTECTION_FACTORY,
        EventTrackService,
        RequestParametersService,
        AppInitializationService,
        Platform, EXTRA_PLUGINS_BY_API_TOKEN,
        [new Optional(), LoggerService]
      ]
    },
    {
      provide: TranslateLoader,
      useClass: CustomTranslationsLoader
    },
    {
      provide: BOT_PROTECTION_FACTORY,
      useClass: DefaultBotProtectionFactory
    },
    {
      provide: LOG_SERVER_LOGGER_CLIENT_OPTIONS,
      useValue: SSCI_SERVER_LOGGER_CLIENT_OPTIONS
    },
    {
      provide: AIRPORT_CITY_MAPPER_SERVICE_TOKEN,
      useExisting: AirportToCityMapperService
    },
    {
      provide: LAZY_LOADER_SERVICE_TOKEN,
      useExisting: LazyLoaderService
    },
    {
      provide: LIBPHONENUMBER_TOKEN,
      useValue: () => import(/* webpackChunkName: "third-party" */ 'libphonenumber-js/max').then((m) => ({
        isValidPhoneNumber: m.isValidPhoneNumber,
        parsePhoneNumber: m.parsePhoneNumber
      }))
    },
    {
      provide: OverlayConfig,
      useFactory: refxOverlayConfig,
      deps: [TextDirectionality]
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        ...refxFormFieldOptions,
        floatLabel: 'always'
      }
    },
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: refxRippleOptions
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: refxDialogConfig
    },
    {
      provide: EVENT_TRACK_SERVICE_CONFIGURATION,
      useValue: {
        useBrowserApiForFirstFP: true
      }
    },
    {
      provide: CUSTOM_LOCALIZATION_CONFIGURATION_TOKEN,
      useFactory: getAppLocaleFactory(environment),
      deps: [RequestParametersService, DynamicLocaleService]
    },
    {
      provide: MESSAGE_FORMAT_CONFIG,
      useValue: {
        enableCache: true,
        ignoreTag: true
      }
    },
    {
      provide: USER_RUNTIME_CHECKS,
      useFactory: getRuntimeChecksConfig(environment),
      deps: [DOCUMENT, RequestParametersService]
    },
    {
      provide: EXTENSION_FEATURE_FLAGS_TOKEN,
      useValue: DEFAULT_FEATURE_FLAGS,
      multi: true
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: refxStepperGlobalOptions
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: dateFnsFormatDMY
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: dateFnsLocaleEnGB
    },
    {
      provide: DateAdapter,
      useClass: GregorianDateFnsAdapter
    },
    {
      provide: RULES_ENGINE_OPTIONS,
      useFactory: getRulesEngineOptions,
      deps: [DOCUMENT, RequestParametersService]
    },
    {
      provide: EXTRA_PLUGINS_BY_API_TOKEN,
      useValue: DEFAULT_EXTRA_PLUGINS_BY_API
    },
    {
      provide: EXPERIMENT_ANALYTICS_INTERFACE_TOKEN,
      useExisting: AnalyticsService
    },
    ...customProviders
  ]
})
export class AppModule {}
